import React, { useState, useEffect } from "react";
import { db } from "../firebase/firestore"; // adjust the path as needed
import {
  collection,
  setDoc,
  updateDoc,
  doc,
  getDocs,
  getDoc,
} from "firebase/firestore";
import { IoCloseCircleSharp } from "react-icons/io5";
import { FaSpinner } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const TelegramPanel = () => {
  const [tasks, setTasks] = useState([]);
  const [taskData, setTaskData] = useState({
    title: "",
    id: "",
    icon: "/telegram.svg",
    link: "",
    rouletteSpin: 0,
    slotSpin: 0,
    cheesePoint: 0,
    multiplierPoint: 0,
    validityPeriod: "1",
    completions: {
      //   completed: false,
    },
  });
  const [showTaskInputs, setShowTaskInputs] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [currentTaskId, setCurrentTaskId] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);

  const navigate = useNavigate();

  // Generate array of days from 2 to 24
  const validityOptions = Array.from({ length: 23 }, (_, i) =>
    (i + 2).toString()
  );

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    const querySnapshot = await getDocs(collection(db, "twitterTasks"));
    const tasksList = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setTasks(tasksList);
    setFetchLoading(false);
  };

  const fetchCounter = async () => {
    const counterDoc = await getDoc(doc(db, "counters", "twitterTaskCounter"));
    if (counterDoc.exists()) {
      return counterDoc.data().currentId;
    } else {
      await setDoc(doc(db, "counters", "twitterTaskCounter"), { currentId: 0 });
      return 0;
    }
  };

  const incrementCounter = async () => {
    const currentId = await fetchCounter();
    const newId = currentId + 1;
    await setDoc(doc(db, "counters", "twitterTaskCounter"), {
      currentId: newId,
    });
    return newId;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTaskData({
      ...taskData,
      [name]:
        name === "multiplierPoint" ||
        name === "cheesePoint" ||
        name === "slotSpin" ||
        name === "rouletteSpin"
          ? value === ""
            ? 0
            : Number(value)
          : value,
    });
  };

  const handleAddTask = async () => {
    setLoading(true);
    try {
      const newId = await incrementCounter();
      const taskDoc = doc(db, "twitterTasks", newId.toString());
      await setDoc(taskDoc, { ...taskData, id: newId });
      setSuccessMessage("Task successfully added!");
      setShowTaskInputs(false);
      setTaskData({
        title: "",
        id: "",
        icon: "/telegram.svg",
        link: "",
        rouletteSpin: 0,
        slotSpin: 0,
        cheesePoint: 0,
        multiplierPoint: 0,
        validityPeriod: "1",
        completions: {
          //   completed: false,
        },
      });
      setLoading(false);
      navigate("/dashboardAdx/managetasks");
      fetchTasks();
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  };

  const handleUpdateTask = async () => {
    setLoading(true);
    const taskDoc = doc(db, "twitterTasks", currentTaskId.toString());
    try {
      await updateDoc(taskDoc, {
        title: taskData.title,
        link: taskData.link,
        rouletteSpin: taskData.rouletteSpin,
        slotSpin: taskData.slotSpin,
        cheesePoint: taskData.cheesePoint,
        multiplierPoint: taskData.multiplierPoint,
        validityPeriod: taskData.validityPeriod,
        // completed: taskData.completed,
      });
      setLoading(false);
      setSuccessMessage("Task successfully updated!");
      setShowTaskInputs(false);
      setTaskData({
        title: "",
        id: "",
        icon: "/telegram.svg",
        link: "",
        rouletteSpin: 0,
        slotSpin: 0,
        cheesePoint: 0,
        multiplierPoint: 0,
        validityPeriod: "1",
        completions: {
          //   completed: false,
        },
      });
      setIsEditing(false);
      setCurrentTaskId("");
      fetchTasks();
    } catch (e) {
      console.error("Error updating document: ", e);
    }
  };

  const cancelEdits = () => {
    setIsEditing(false);
    setShowTaskInputs(!showTaskInputs);
    setTaskData({
      title: "",
      id: "",
      icon: "/telegram.svg",
      link: "",
      rouletteSpin: 0,
      slotSpin: 0,
      cheesePoint: 0,
      multiplierPoint: 0,
      validityPeriod: "1",
      completions: {
        // completed: false,
      },
    });
  };

  return (
    <>
      {fetchLoading ? (
        <div className="w-full flex h-50dvh justify-center items-center">
          <FaSpinner size={26} />
        </div>
      ) : (
        <div
          id="refer"
          className="w-full flex flex-col space-y-4 h-[100vh] scroller pt-4 overflow-y-auto pb-[150px]"
        >
          <div className="w-full mt-4 flex justify-between align-center">
            <h1 className="text-xl md:text-2xl font-bold mb-6">
              Add Telegram task
            </h1>
          </div>

          <>
            <div className="flex w-full flex-wrap gap-3">
              <div className="flex flex-col w-full sm:w-[49%] gap-1">
                <label className="text-[13px] pl-1 pb-[2px] font-medium">
                  Task title
                </label>

                <input
                  type="text"
                  name="title"
                  value={taskData.title}
                  onChange={handleInputChange}
                  placeholder="Title"
                  className="bg-[#4b4b4b] w-full placeholder:text-[#b9b9b9] text-[#e0e0e0] placeholder:text-[12px] text-[13px] placeholder:font-light h-[55px] border-none outline-none rounded-[10px] flex items-center px-6"
                />
              </div>

              <div className="flex flex-col w-full sm:w-[49%] gap-1">
                <label className="text-[13px] pl-1 pb-[2px] font-medium">
                  Task url
                </label>

                <input
                  type="url"
                  name="link"
                  value={taskData.link}
                  onChange={handleInputChange}
                  placeholder="Link"
                  className="bg-[#4b4b4b] placeholder:text-[#b9b9b9] text-[#e0e0e0] placeholder:text-[12px] text-[13px] placeholder:font-light h-[55px] border-none outline-none rounded-[10px] flex items-center px-6"
                />
              </div>
              <div className="flex flex-col w-full sm:w-[49%] gap-1">
                <label className="text-[13px] pl-1 pb-[2px] font-medium">
                  Task Validity Period (Days)
                </label>
                <select
                  name="validityPeriod"
                  value={taskData.validityPeriod}
                  onChange={handleInputChange}
                  className="bg-[#4b4b4b] text-[#e0e0e0] text-[13px] h-[55px] border-none outline-none rounded-[10px] px-6"
                >
                  {validityOptions.map((days) => (
                    <option key={days} value={days}>
                      {days} days
                    </option>
                  ))}
                </select>
              </div>

              <div className=" w-full flex gap-4 sm:w-[49%]">
                <div className="flex flex-col w-full gap-1">
                  <label className="text-[13px] pl-1 pb-[2px] font-medium">
                    Roullete Spin
                  </label>

                  <input
                    type="number"
                    name="rouletteSpin"
                    value={taskData.rouletteSpin}
                    onChange={handleInputChange}
                    placeholder="input number"
                    className="bg-[#4b4b4b] placeholder:text-[#b9b9b9] text-[#e0e0e0] placeholder:text-[12px] text-[13px] placeholder:font-light h-[55px] border-none outline-none rounded-[10px] flex items-center px-6"
                  />
                </div>
                <div className="flex flex-col w-full gap-1">
                  <label className="text-[13px] pl-1 pb-[2px] font-medium">
                    Slot Spin
                  </label>

                  <input
                    type="number"
                    name="slotSpin"
                    value={taskData.slotSpin}
                    onChange={handleInputChange}
                    placeholder="input number"
                    className="bg-[#4b4b4b] placeholder:text-[#b9b9b9] text-[#e0e0e0] placeholder:text-[12px] text-[13px] placeholder:font-light h-[55px] border-none outline-none rounded-[10px] flex items-center px-6"
                  />
                </div>
              </div>
              <div className=" w-full flex gap-4 sm:w-[49%]">
                <div className="flex flex-col w-full gap-1">
                  <label className="text-[13px] pl-1 pb-[2px] font-medium">
                    Cheese Points
                  </label>

                  <input
                    type="number"
                    name="cheesePoint"
                    value={taskData.cheesePoint}
                    onChange={handleInputChange}
                    placeholder="input number"
                    className="bg-[#4b4b4b] placeholder:text-[#b9b9b9] text-[#e0e0e0] placeholder:text-[12px] text-[13px] placeholder:font-light h-[55px] border-none outline-none rounded-[10px] flex items-center px-6"
                  />
                </div>
                <div className="flex flex-col w-full gap-1">
                  <label className="text-[13px] pl-1 pb-[2px] font-medium">
                    3x Multiplier Spin
                  </label>

                  <input
                    type="number"
                    name="multiplierPoint"
                    value={taskData.multiplierPoint}
                    onChange={handleInputChange}
                    placeholder="input number"
                    className="bg-[#4b4b4b] placeholder:text-[#b9b9b9] text-[#e0e0e0] placeholder:text-[12px] text-[13px] placeholder:font-light h-[55px] border-none outline-none rounded-[10px] flex items-center px-6"
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              {isEditing ? (
                <>
                  <button
                    onClick={handleUpdateTask}
                    className="bg-green-500 font-semibold text-[15px] rounded-[6px] w-full sm:w-[200px] h-fit px-4 py-3 text-[#fff]"
                  >
                    {loading ? "updating..." : "Update Task"}
                  </button>
                  <button
                    onClick={cancelEdits}
                    className="bg-[#4a3a3a] font-semibold text-[15px] rounded-[6px] w-full sm:w-[200px] h-fit px-4 py-3 text-[#fff]"
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={handleAddTask}
                    className="bg-[#f5bb5f] font-semibold text-[15px] rounded-[6px] w-full sm:w-[200px] h-fit px-4 py-3 text-[#000]"
                  >
                    {loading ? "Adding..." : "Add Task"}
                  </button>
                  <button
                    onClick={() => navigate("/dashboardAdx/managetasks")}
                    className="bg-[#4a3a3a] font-semibold text-[15px] rounded-[6px] w-full sm:w-[200px] h-fit px-4 py-3 text-[#fff]"
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          </>

          {successMessage && (
            <div className="modal fixed w-full h-full top-0 left-0 flex items-center justify-center">
              <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
              <div className="modal-container bg-[#595D65] w-11/12 md:max-w-md mx-auto rounded-[10px] shadow-lg z-50 overflow-y-auto">
                <div className="modal-content py-4 text-left px-6">
                  <div className="flex justify-end items-center pb-3">
                    <div
                      className="modal-close cursor-pointer z-50"
                      onClick={() => setSuccessMessage("")}
                    >
                      <IoCloseCircleSharp
                        size={32}
                        className="text-secondary"
                      />
                    </div>
                  </div>
                  <div className="flex justify-center items-center">
                    <p>{successMessage}</p>
                  </div>
                  <div className="flex justify-center pt-2">
                    <button
                      className="modal-close bg-blue-500 text-white p-2 px-6 rounded"
                      onClick={() => setSuccessMessage("")}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TelegramPanel;
